import { render, staticRenderFns } from "./RoomsHistory.vue?vue&type=template&id=244a798a&scoped=true"
import script from "./RoomsHistory.vue?vue&type=script&lang=js"
export * from "./RoomsHistory.vue?vue&type=script&lang=js"
import style0 from "./RoomsHistory.vue?vue&type=style&index=0&id=244a798a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244a798a",
  null
  
)

export default component.exports